<template>
  <el-card>
    <app-breadcrumb :items="items"></app-breadcrumb>
    <app-table-paginate
      :key="reload"
      v-if="tableShow"
      :preview="'access-history/date-history/'"
      :previewCustom="'acces_date'"
      routeDelete="no"
      selection="no"
      :tableQuery="getList"
      :tableColumns="tableColumns"
      :limit="limit"
      :search="false"
    ></app-table-paginate>
  </el-card>
</template>

<script>
import ApiService from "@/common/api.service";
import tablaConPaginador from "@/components/_commons/tablaConPaginador";
import moment from "moment-timezone";
import breadcrumb from "@/components/_commons/breadcrumb";

export default {
  name: "historico-de-acceso-date",
  components: {
    "app-table-paginate": tablaConPaginador,
    "app-breadcrumb": breadcrumb
  },
  created() {
    this.get();
  },
  data() {
    return {
      reload: 0,
      items: [
        {
          path: "/auditoria/",
          label: "auditoria"
        },
        {
          path: "/auditoria/access-history",
          label: "Histórico de accesos"
        }
      ],
      listAPI: false,
      loading: true,
      tableColumns: [
        {
          prop: "acces_date",
          label: "Fecha"
        }
      ],
      searchQuery: "",
      deleterow: false,
      limit: 10,
      tableShow: true
    };
  },
  methods: {
    async get() {
      const response = await ApiService.post("auditoria/access-data-history", {
        token: localStorage.getItem("token")
      });
      this.listAPI = response.data.filter(e => {
        e.acces_date = moment(e.access_data).format("DD-MM-YYYY");
        return e;
      });
      this.reload++;
    }
  },
  computed: {
    getList() {
      return this.listAPI;
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/auditoria/accessDatehistory.vue